import React from 'react';
import {
  StyleSheet, Document, Page, View, Text
} from '@react-pdf/renderer';
import { toBrazilDateTime } from '../../../components/mask';

export interface CallRemittanceExportRow {
  Identificação: string;
  'Data e horário': string;
  Origem: string;
  'Valor contratante': string;
  'Valor Juma': string;
  'Valor entregador': string;
  'Taxas/comissões': string;
  Entregador: string;
  Distância: string;
}

interface OwnProps {
  data: CallRemittanceExportRow[];
  fileName: string;
  filters: {
    subsidiary: string;
    period: string;
  };
  totalRecords: number;
  truncated: boolean;
}

export default function CallsRemittancePrint({
  data,
  fileName,
  filters,
  totalRecords,
  truncated
}: OwnProps) {
  const styles = StyleSheet.create({
    body: {
      padding: 12,
      paddingBottom: 50
    },
    table: {
      width: 'auto',
      borderStyle: 'solid',
      borderColor: '#bfbfbf',
      borderWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0
    },
    tableRow: {
      flexDirection: 'row'
    },
    colHeader: {
      borderStyle: 'solid',
      borderColor: '#bfbfbf',
      borderBottomColor: '#000',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      padding: 3
    },
    col: {
      borderStyle: 'solid',
      borderColor: '#bfbfbf',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      padding: 2
    },
    tableCellHeader: {
      fontSize: 7,
      fontWeight: 500,
      textAlign: 'center'
    },
    tableCell: {
      fontSize: 6
    },
    header: {
      fontSize: 12,
      marginBottom: 8,
      textAlign: 'center',
      color: 'grey'
    },
    filters: {
      fontSize: 9,
      marginBottom: 10,
      textAlign: 'center',
      color: 'darkgrey'
    },
    total: {
      fontSize: 9,
      marginTop: 8,
      textAlign: 'right',
      fontWeight: 'bold'
    },
    pageNumber: {
      position: 'absolute',
      fontSize: 9,
      bottom: 20,
      left: 0,
      right: 0,
      textAlign: 'center',
      color: 'grey'
    }
  });

  const widths: Record<string, string> = {
    Identificação: '14%',
    'Data e horário': '12%',
    Origem: '12%',
    'Valor contratante': '10%',
    'Valor Juma': '10%',
    'Valor entregador': '10%',
    'Taxas/comissões': '12%',
    Entregador: '10%',
    Distância: '10%'
  };

  const firstRow = data[0] || {};
  const rowKeys = Object.keys(firstRow);

  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.body}>
        <Text style={styles.header} fixed>
          Relatório de remunerações e taxas
          {'\n'}
          {fileName}
          {'\n'}
          {toBrazilDateTime(new Date())}
        </Text>

        <Text style={styles.filters} fixed>
          Franquia:
          {' '}
          {filters.subsidiary}
          {'\n'}
          Período:
          {' '}
          {filters.period}
        </Text>

        <View style={styles.table}>
          <View style={styles.tableRow}>
            {rowKeys.map((key) => (
              <View style={[styles.colHeader, { width: widths[key] || '10%' }]} key={`header-${key}`}>
                <Text style={styles.tableCellHeader}>{key}</Text>
              </View>
            ))}
          </View>
          {data.map((row) => (
            <View style={styles.tableRow} key={`row-${row.Identificação}-${row['Data e horário']}`} wrap={false}>
              {Object.entries(row).map(([key, value]) => (
                <View
                  style={[styles.col, { width: widths[key] || '10%' }]}
                  key={`cell-${row.Identificação}-${key}`}
                >
                  <Text style={styles.tableCell}>{String(value)}</Text>
                </View>
              ))}
            </View>
          ))}
        </View>

        <Text style={styles.total} fixed>
          {`TOTAL: ${totalRecords} entrega${totalRecords !== 1 ? 's' : ''}`}
          {truncated ? ' (PDF limitado aos primeiros registros; use Excel/CSV para a lista completa)' : ''}
        </Text>

        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) => (
            `${pageNumber} / ${totalPages}`
          )}
          fixed
        />
      </Page>
    </Document>
  );
}
